'use client';

import { useEffect, useState } from 'react';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('cookie-consent');
    if (!stored) setShow(true);
  }, []);

  const handleConsent = (granted: boolean) => {
    localStorage.setItem('cookie-consent', granted ? 'granted' : 'denied');
    setShow(false);
    if (granted) {
      window.dispatchEvent(new Event('cookie-consent-update'));
    }
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4 sm:px-6">
      <div className="max-w-xl mx-auto flex items-center justify-between gap-4">
        <p className="text-sm text-gray-600">
          서비스 개선을 위해 쿠키를 사용합니다.{' '}
          <a href="/privacy" className="underline text-[#1A3A5C]">개인정보 처리방침</a>
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => handleConsent(false)}
            className="px-3 py-1.5 text-sm text-gray-500 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            거부
          </button>
          <button
            onClick={() => handleConsent(true)}
            className="px-3 py-1.5 text-sm text-white bg-[#1A3A5C] rounded-lg hover:bg-[#1A3A5C]/90"
          >
            동의
          </button>
        </div>
      </div>
    </div>
  );
}
